import VueRouter from "vue-router";
// 门户首页
import HomePage from "@/views/Home/HomePage.vue";
// 文章列表
import ArticlePage from "@/views/articles/index.vue";
// 文章详情
import ArticlesDetail from "@/views/articles/detail.vue"
// 编辑文章列表，增删改查
// import ArticlesPage from "@/views/cds/articles.vue"
// 发布文章页，富文本编辑器
// import EditerPage from "@/views/cds/editer.vue"


const routes = [
  { path: "/", component: HomePage, },
  { path: "/article", component: ArticlePage, },
  { path: "/detail", component: ArticlesDetail, },
  // { path: "/articles", component: ArticlesPage, },
  // { path: "/editer", component: EditerPage, },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  next();
})

export default router
